import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/delete.vue
var s = {
	name: "DtIconDelete",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--delete"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Delete",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [i("g", {
		"clip-path": `url(#${e.uniqueID}a)`,
		fill: "currentColor"
	}, [...t[0] || (t[0] = [i("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M4.147 2.147A.5.5 0 0 1 4.5 2H10a1.5 1.5 0 0 1 1.5 1.5v5A1.5 1.5 0 0 1 10 10H4.5a.5.5 0 0 1-.353-.146l-3.5-3.5a.5.5 0 0 1 0-.707l3.5-3.5Zm.56.853-3 3 3 3H10a.5.5 0 0 0 .5-.5v-5A.5.5 0 0 0 10 3H4.707Z"
	}, null, -1), i("path", { d: "M9.354 4.147a.5.5 0 0 1 0 .707L8.207 6l1.147 1.147a.5.5 0 0 1-.707.707L7.5 6.707 6.354 7.854a.5.5 0 0 1-.707-.707L6.793 6 5.647 4.854a.5.5 0 0 1 .707-.707L7.5 5.293l1.147-1.146a.5.5 0 0 1 .707 0Z" }, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=delete.js.map